const ROOT = `${process.env.REACT_APP_URL_API_V2}cities`
// const ROOT = 'cities/'

export default {
	arrayListDropdown: `${ROOT}`
}
